import ButtonLoadingContent from '../../../../shared/Loading/ButtonLoadingContent';

const Send = ({ loading }) => {
  return (
    <button
      type="submit"
      disabled={loading}
      className={`w-full text-white text-xs py-1 transition border ${
        loading
          ? 'bg-purple-200 cursor-not-allowed'
          : 'bg-personalized hover:bg-white hover:text-personalized hover:border-personalized'
      }`}
    >
      <ButtonLoadingContent loading={loading}>
        Enviar enlace de recuperación
      </ButtonLoadingContent>
    </button>
  );
};

export default Send;
